import { GQL_ID, Product } from '@@types'
import { gql, useQuery } from '@apollo/client'


export const GQL_QUERY_SIMILAR_PRODUCTS = gql`
  query SimilarProducts($shopId: ID!, $productId: ID!, $style: String) {
    similarProducts(shop_id: $shopId, product_id: $productId) {
      id
      xid
      name
      slug
      price_type
      weight
      weight_netto
      weight_multiplier
      pkg
      brand {
        id
        name
      }
      preview(style: $style) {
        url
      }
      review_count
      average_rating
      is_alcohol
      isFavorite
      isWeightProduct
      marketingLabels {
        id
        title
        description
        image(style: "600xauto") {
          url
        }
        activeFrom
        activeUntil
        optionColor
        optionBackgroundColor
        optionLink
        optionLinkLabel
      }
      timeRestrictions {
        from
        to
      }
      stock {
        amount
      }
      priceOffer @client {
        id
        price
        oldPrice
        salePeriod {
          start
          finish
        }
        min
        max
        step
        quant
        quantAmount
        uiQuant
        isDefault
        group
        count_multiplier
      }
      priceOffers {
        id
        price
        oldPrice
        salePeriod {
          start
          finish
        }
        min
        max
        step
        quant
        quantAmount
        uiQuant
        isDefault
        group
      }
    }
  }
`


interface SimilarProductsVariables {
  shopId: GQL_ID;
  productId: GQL_ID;
  style?: string;
}


interface SimilarProductsQuery {
  similarProducts?: Product[];
}

export const useFetchSimilarProducts = (variables: SimilarProductsVariables) => {
  const { data, loading, error, ...rest } = useQuery<SimilarProductsQuery, SimilarProductsVariables>(
    GQL_QUERY_SIMILAR_PRODUCTS,
    {
      variables,
      fetchPolicy: 'cache-first',
      nextFetchPolicy: 'cache-first',
      notifyOnNetworkStatusChange: true,
    }
  )


  const similarProducts = data?.similarProducts || []


  return {
    similarProducts,
    data,
    loading,
    error,
    ...rest,
  }
}
